<template>
  <v-app id="login" class="primary darken-4">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <img
                    src="/images/logo/jaque-128.png"
                    alt="Sistema Administración Interna"
                    width="120"
                    height="120"
                  />
                  <h1 class="flex my-2 primary--text">JAQUE SAI</h1>

                  <h3 style="color: red">V. {{ this.$store.state.version }}</h3>
                </div>
                <v-form>
                  <v-text-field
                    append-icon="person"
                    name="login"
                    label="Login"
                    type="text"
                    v-model="usuario.aliasUsuario"
                    v-on:keyup.enter="login"
                  ></v-text-field>
                  <v-text-field
                    append-icon="lock"
                    name="password"
                    label="Password"
                    id="password"
                    type="password"
                    v-model="usuario.password"
                    v-on:keyup.enter="login"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn icon>
                  <v-icon color="blue">fa fa-facebook-square fa-lg</v-icon>
                </v-btn>
                <v-btn icon>
                  <v-icon color="red">fa fa-google fa-lg</v-icon>
                </v-btn>
                <v-btn icon>
                  <v-icon color="light-blue">fa fa-twitter fa-lg</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  block
                  color="primary darken-4"
                  @click="login"
                  :loading="loading"
                  >Iniciar Sesión</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <snack-bar></snack-bar>
  </v-app>
</template>

<script>
import authService from "@/services/authService";
import sistemaService from "@/services/sistemaService";

import snackBar from "@/components/SnackBar";

export default {
  components: {
    snackBar,
  },
  data: () => ({
    loading: false,
    usuario: {
      // aliasUsuario: "Administrador",
      // password: "admin,2019"
      aliasUsuario: "",
      password: "",
    },
  }),
  created() {
    sistemaService.getVersion().then((result) => {
      this.$store.state.version = result;
    });
  },
  methods: {
    login() {
      let self = this;
      this.loading = true;
      self.usuario.password = Sha256.hash(self.usuario.password);

      authService
        .logIn(self.usuario)
        .then((result) => {
          let token = result["token_type"];
          if (token != null) {
            self.startSesion(result);
          }
        })
        .catch((e) => {
          console.log(e);
          self.$store.state.snackbar.color = "error";
          self.$store.state.snackbar.text = e.response.data.error;
          self.$store.state.snackbar.visible = true;
          self.usuario.password = "";
        })
        .finally((r) => {
          self.loading = false;
        });
    },
    startSesion(result) {
      let self = this;
      var token = result["token_type"] + " " + result["access_token"];
      var expiracion = this.getExpiracion(result);

      localStorage.setItem("esAnonimo", "false");
      localStorage.setItem("access_token", token);
      localStorage.setItem("expiracion_token", JSON.stringify(expiracion));

      this.getCurrentUser();
      
      self.$nextTick(() => {
    
        this.$router.push("/home");
       
      });
    },
    getExpiracion(result) {
      let expiracion_token = result["expires_in"] - 15;
      let expiracion_milisegundos = expiracion_token * 1000;
      let hora_inicial = new Date().getTime();
      let hora_final = hora_inicial + expiracion_milisegundos;

      return {
        horaInicial: hora_inicial,
        tiempo: expiracion_milisegundos,
        horaFinal: hora_final,
      };
    },
  },
};
</script>

<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
</style>
